export default __webpack_public_path__ + "static/media/search.9d539cb8.svg";